/**
 * Texts (`en`) of the Stock views BY PLACE and BY ARTICLE and of the multiple move (OBR-145). Namespace `backoffice.stockViews`. Same
 * keys as `views.ca.ts` (`views.test.ts` and i18n.test.ts); no literal text in the views.
 */

export const viewsEn = {
  'backoffice.stockViews': {
    modeLabel: 'Stock view',
    modePlaces: 'By place',
    modeArticles: 'By article',

    treeLabel: 'Places of the workshop',
    treeHint: 'Pick a place to see what is there. Only the picked place is read.',
    treeExpand: 'Expand {{place}}',
    treeCollapse: 'Collapse {{place}}',
    treeNoStock: 'No stock',
    treeInactive: 'Retired',
    treeNoPlaceHint: 'What was received before the workshop structure existed.',
    treeEmptyStructure:
      'The workshop has no zone defined yet. You can see what has no place under “No place” and define the structure in Settings.',
    structureLoadError:
      'The workshop structure (zones, sections and locations) could not be read, so it cannot be said that there is none. Try again.',
    leadDaysUnknown:
      'The workshop expiry warning days could not be read: it cannot be said which lots expire soon, and the ones that have not expired yet are shown without colour.',

    placeLinesCount_one: '{{count}} lot',
    placeLinesCount_other: '{{count}} lots',
    placeMore: 'There are more lots in this place: load more.',
    placeEmpty: 'There is no stock in this place.',
    placeEmptyNone: 'Everything has a place: no stock without a place.',
    placeLoadError: 'The stock of this place could not be loaded. Try again.',
    placeLoadMoreError: 'More lots could not be loaded. Try again.',
    placeRetry: 'Try again',
    loadMore: 'Load more',
    loadingMore: 'Loading…',
    groupLabel: 'Place: {{place}}',

    cardNoLot: 'No lot',
    cardSupplierLot: 'Supplier lot: {{code}}',
    cardExpiry: 'Expiry',
    cardPlace: 'Place',
    selectLine: 'Select lot {{lot}} to move it',
    selectNoStock: 'There is no stock in this place: nothing to move.',
    selectUntracked: 'This article has no stock control: nothing to move.',
    selectArticleGone: 'This article has been retired: it cannot be moved.',

    expiryNone: 'No expiry',
    expiryToday: 'Expires today',
    expiryTomorrow: 'Expires tomorrow',
    expiryIn: 'Expires in {{count}} days',
    expiryYesterday: 'Expired yesterday',
    expiryAgo: 'Expired {{count}} days ago',

    timelineTitle: 'Expiry dates',
    timelineAria: 'Timeline of the expiry dates of the lots in stock',
    timelineToday: 'Today',
    timelineSoon: 'Expires soon',
    timelineDayUnit: 'd',
    timelineLegendExpired: 'Expired',
    timelineLegendSoon: 'Expires soon',
    timelineLegendOk: 'Plenty of time',
    timelineUndated: 'No expiry: {{lots}}',
    timelineEmpty: 'No lot with stock and an expiry date to draw.',
    timelineBar: '{{lot}}: {{when}}',

    selectionCount_one: '{{count}} lot selected',
    selectionCount_other: '{{count}} lots selected',
    selectionMove: 'Move the selection',
    selectionClear: 'Clear the selection',
    selectionDropped:
      '{{count}} lots were removed from the selection because they can no longer be moved (they changed or have no stock left).',
    moveDone_one: '{{count}} lot was moved to {{place}}.',
    moveDone_other: '{{count}} lots were moved to {{place}}.',
    moveDoneDismiss: 'Dismiss',

    batchTitle: 'Move the selection',
    batchBody:
      'All the lots go to the same place. Each lot’s quantity starts as everything held at the origin; lower it to move only part. If one lot fails, none is moved.',
    batchDestination: 'Destination place',
    batchDestinationPlaceholder: 'Pick where they go',
    batchNote: 'Note',
    batchNotePlaceholder: 'Optional: why they are moved',
    batchColLot: 'Lot',
    batchColFrom: 'Origin',
    batchColQuantity: 'Quantity to move',
    batchColRemaining: 'Will remain at the origin',
    batchAvailable: '{{quantity}} {{unit}} available',
    batchAtDestination: 'Already at the destination: it will not be moved.',
    batchQuantityInvalid: 'Enter a quantity greater than zero.',
    batchQuantityExceeds: 'It cannot exceed the {{quantity}} {{unit}} held at the origin.',
    batchNotSelectable: 'This lot can no longer be moved.',
    batchSummary_one: '{{count}} lot will be moved to {{place}}.',
    batchSummary_other: '{{count}} lots will be moved to {{place}}.',
    batchSkipped_one: '{{count}} lot is already at the destination and will not be moved.',
    batchSkipped_other: '{{count}} lots are already at the destination and will not be moved.',
    batchTooMany: 'One move takes at most {{max}} lots. Remove some from the selection.',
    batchWarning:
      'The selection includes blocked or expired lots. They can be moved, but cannot be consumed or shipped. Lots blocked by hand arrive blocked at the destination: quarantine follows the goods.',
    batchNoDestinations: 'There is no destination place that accepts stock. Define one in Settings.',
    batchConfirm: 'Move',
    batchFailed: 'Nothing was moved. {{reason}}',
    batchFailedItem: 'Nothing was moved. Lot {{lot}} ({{article}}): {{reason}}',
    batchFailedHint: 'You can fix it and press “Move” again.',

    err_move_stock_batch_empty: 'There is no lot to move.',
    err_move_stock_batch_too_large: 'Too many lots in one move (200 at most).',
    err_move_stock_batch_client_uuid_conflict:
      'This operation already belongs to another move. Reopen the dialog and try again.',
    err_move_stock_forbidden: 'You do not have permission to move stock.',
    err_move_stock_no_tenant: 'The workshop could not be identified. Sign in again.',
    err_move_stock_batch_bad_item: 'The data of this lot is not valid.',
    err_move_stock_batch_duplicate: 'This lot leaves the same place twice.',
    err_move_stock_batch_chained: 'The destination of one lot is the origin of another of the same lot.',
    err_move_stock_insufficient:
      'The origin no longer holds enough stock: it changed since you picked the lot. Check it again.',
    err_move_stock_same_place: 'This lot is already at the destination place.',
    err_move_stock_no_destination: 'Pick a destination place.',
    err_move_stock_bad_destination: 'The destination place no longer exists or is not in this workshop.',
    err_move_stock_destination_without_stock: 'The destination place does not accept stock.',
    err_move_stock_two_lots: 'A movement belongs to a single lot.',
    err_move_stock_unknown_article: 'This article no longer exists in this workshop.',
    err_move_stock_unknown_lot: 'This lot no longer exists or is not of this article.',
    err_move_stock_bad_quantity: 'The quantity is not valid.',
    err_unknown: 'The move could not be made.',
  },
} as const;
